import { Action } from '@ngrx/store';
import { IAppointment, IVehicle, SortOrder } from '@signal/asp-data-commons';
import { IPendingResponse } from './bdcdashboard.reducer';

export enum BdcDashboardActionTypes {
  LOAD_USER_VEHICLES = '[App component] Load user vehicles',
  LOAD_USER_VEHICLES_SUCCESS = '[DCS API] Load user vehicles success',
  LOAD_USER_VEHICLES_FAILURE = '[DCS API] Load user vehicles failure',
  LOAD_APPOINTMENTS = '[BdcDashboard page] Load user appointments',
  LOAD_APPOINTMENTS_FOR_VIN = '[BdcDashboard page] Load user appointments for vin',
  LOAD_APPOINTMENTS_SUCCESS = '[ASP API] Load user appointments success',
  LOAD_APPOINTMENTS_SUCCESS_FOR_VIN = '[ASP API] Load user appointments success for vin',
  LOAD_APPOINTMENTS_FAILURE = '[ASP API] Load user appointments failure',
  UPSERT_APPOINTMENT = '[Service appointment] Upsert user appointment',
  CANCEL_APPOINTMENT_FROM_BDCDASHBOARD = '[BdcDashboard page] Cancel an appointment',
  CANCEL_APPOINTMENT_FROM_CONFIRM = '[Confirm page] Cancel an appointment',
  CANCEL_APPOINTMENT_SUCCESS = '[ASP API] Cancel an appointment success',
  CANCEL_APPOINTMENT_FAILURE = '[ASP API] Cancel an appointment failure',
  CLEAR_USER_VEHICLES = '[BdcDashboard page] Clear user vehicles',
  LOAD_PENDING_APPOINTMENTS = '[BdcDashboard page] Load pending appointments',
  LOAD_PENDING_APPOINTMENTS_SUCCESS = '[BdcDashboard page] Load pending appointments success',
  LOAD_PENDING_APPOINTMENTS_FAILURE = '[BdcDashboard page] Load pending appointments failure',
  CANCEL_PENDING_APPOINTMENTS = '[BdcDashboard page] cancel pending appointments',
  CANCEL_PENDING_APPOINTMENTS_SUCCESS = '[BdcDashboard page] cancel pending appointments success',
  CANCELPENDING_APPOINTMENTS_FAILURE = '[BdcDashboard page] cancel pending appointments failure',
  SEND_LINK_TO_CUSTOMER = '[BdcDashboard page] Send link to customer',
  SEND_LINK_TO_CUSTOMER_SUCCESS = '[BdcDashboard page] Send link to customer success',
  SEND_LINK_TO_CUSTOMER_FAILURE = '[BdcDashboard page] Send link to customer failure',
  LOAD_SEARCH_PENDING_APPOINTMENTS = '[BdcDashboard page] Load search pending appointments'
}

export class LoadUserVehicles implements Action {
  readonly type: string = BdcDashboardActionTypes.LOAD_USER_VEHICLES;

  constructor(public payload: { dealerCode: string, customerId: string }) {
  }
}

export class ClearUserVehicles implements Action {
  readonly type: string = BdcDashboardActionTypes.CLEAR_USER_VEHICLES;

  constructor() {
  }
}

export class LoadUserVehiclesSuccess implements Action {
  readonly type = BdcDashboardActionTypes.LOAD_USER_VEHICLES_SUCCESS;

  constructor(public payload: { vehicles: IVehicle[] }) {
  }
}

export class LoadUserVehiclesFail implements Action {
  readonly type = BdcDashboardActionTypes.LOAD_USER_VEHICLES_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadAppointments implements Action {
  readonly type: string = BdcDashboardActionTypes.LOAD_APPOINTMENTS;

  constructor(public payload: { queryText: string }) {
  }
}

export class LoadAppointmentsForVin implements Action {
  readonly type: string = BdcDashboardActionTypes.LOAD_APPOINTMENTS_FOR_VIN;

  constructor(public payload: { queryText: string }) {
  }
}

export class LoadAppointmentsSuccess implements Action {
  readonly type = BdcDashboardActionTypes.LOAD_APPOINTMENTS_SUCCESS;

  constructor(public payload: { appointments: IAppointment[] }) {
  }
}
export class LoadAppointmentsSuccessForVin implements Action {
  readonly type = BdcDashboardActionTypes.LOAD_APPOINTMENTS_SUCCESS_FOR_VIN;

  constructor(public payload: { appointments: IAppointment[] }) {
  }
}

export class LoadAppointmentsFail implements Action {
  readonly type = BdcDashboardActionTypes.LOAD_APPOINTMENTS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class UpsertAppointment implements Action {
  readonly type = BdcDashboardActionTypes.UPSERT_APPOINTMENT;

  constructor(public payload: { appointment: IAppointment }) {
  }
}

export class CancelAppointment {

  constructor(public payload: { appointment: IAppointment }) {
  }
}

export class CancelAppointmentFromBdcDashboard extends CancelAppointment implements Action {
  readonly type: string = BdcDashboardActionTypes.CANCEL_APPOINTMENT_FROM_BDCDASHBOARD;

  constructor(public payload: { appointment: IAppointment }) {
    super(payload);
  }
}

export class CancelAppointmentFromConfirm extends CancelAppointment implements Action {
  readonly type: string = BdcDashboardActionTypes.CANCEL_APPOINTMENT_FROM_CONFIRM;

  constructor(public payload: { appointment: IAppointment }) {
    super(payload);
  }
}

export class CancelAppointmentSuccess implements Action {
  readonly type = BdcDashboardActionTypes.CANCEL_APPOINTMENT_SUCCESS;

  constructor(public payload: { appointmentId: string }) {
  }
}

export class CancelAppointmentFail implements Action {
  readonly type = BdcDashboardActionTypes.CANCEL_APPOINTMENT_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

/* pending appointments screen */
export class LoadPendingAppointments implements Action {
  readonly type: string = BdcDashboardActionTypes.LOAD_PENDING_APPOINTMENTS;

  constructor(public payload: { type: string, offset?: number, limit?: number, sortingField?: string, sortOrder?: string }) {
  }
}

export class LoadPendingAppointmentsSuccess implements Action {
  readonly type: string = BdcDashboardActionTypes.LOAD_PENDING_APPOINTMENTS_SUCCESS;

  constructor(public payload: { appointmentData: IPendingResponse, isLoad?:boolean }) {
  }
}

export class LoadPendingAppointmentsFailure implements Action {
  readonly type: string = BdcDashboardActionTypes.LOAD_PENDING_APPOINTMENTS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class CancelPendingAppointments implements Action {
  readonly type: string = BdcDashboardActionTypes.CANCEL_PENDING_APPOINTMENTS;

  constructor(public payload: { appointment: IAppointment, type?: string, count?: number }) {
  }
}

export class CancelPendingAppointmentsSuccess implements Action {
  readonly type = BdcDashboardActionTypes.CANCEL_PENDING_APPOINTMENTS_SUCCESS;

  constructor(public payload: { appointmentId: string }) {
  }
}

export class CancelPendingAppointmentsFail implements Action {
  readonly type = BdcDashboardActionTypes.CANCELPENDING_APPOINTMENTS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class SendLinkToCustomer implements Action {
  readonly type: string = BdcDashboardActionTypes.SEND_LINK_TO_CUSTOMER;

  constructor(public payload: { appointment: IAppointment }) {
  }
}

export class SendLinkToCustomerSuccess implements Action {
  readonly type = BdcDashboardActionTypes.SEND_LINK_TO_CUSTOMER_SUCCESS;

  constructor(public payload: { appointmentId: string }) {
  }
}

export class SendLinkToCustomerFailure implements Action {
  readonly type = BdcDashboardActionTypes.SEND_LINK_TO_CUSTOMER_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadSearchPendingAppointments implements Action {
  readonly type: string = BdcDashboardActionTypes.LOAD_SEARCH_PENDING_APPOINTMENTS;

  constructor(public payload: {type: string, offset?: number, limit?: number, sortingField: string, sortOrder: string, searchConfig : any, isSearch: boolean}) {
  }
}

export type BdcDashboardActions =
  | LoadUserVehicles
  | LoadUserVehiclesSuccess
  | LoadUserVehiclesFail
  | ClearUserVehicles
  | LoadAppointments
  | LoadAppointmentsForVin
  | LoadAppointmentsSuccess
  | LoadAppointmentsFail
  | UpsertAppointment
  | CancelAppointmentFromBdcDashboard
  | CancelAppointmentSuccess
  | CancelAppointmentFail
  | LoadPendingAppointments
  | LoadPendingAppointmentsSuccess
  | LoadPendingAppointmentsFailure
  | CancelPendingAppointments
  | CancelPendingAppointmentsSuccess
  | CancelPendingAppointmentsFail
  | SendLinkToCustomer
  | SendLinkToCustomerSuccess
  | SendLinkToCustomerFailure
